"use strict";

import "./lib/meteor-shim";
import "./lib/moment-pt-br";
import angular from "angular";
import "./app.module";
import "./main.scss";
import "./shared/shared.module";
import "./views";
import "./routes/app.routes";
import appVersion from "../public/js/version.js";

function bootstrap() {
    const env = process.env.NUCONT_ENV || "development";
    console.info(`[Nucont Pro] v${appVersion} (${env})`);
    angular.bootstrap(document.body, ["nucont"], { strictDi: true });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
} else {
    bootstrap();
}
